import { Component } from '@angular/core';

@Component({
  selector: 'uni-nav',
  templateUrl: './uni-nav.component.html',
  styleUrls: ['./uni-nav.component.scss']
})
export class UniNavComponent {}
